import { FormControl, FormGroup } from '@angular/forms';
import Swal, { SweetAlertIcon } from 'sweetalert2';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UiService {

  private _swal = Swal;

  /**
   * Show a loading spinner with the title 'title' and the text 'Cargando...' and don't allow the user
   * to click outside the spinner.
   * @param {string} title - The title of the loading dialog
   */
  showLoading( title: string ){
    this._swal.fire({
      title, 
      text: "Cargando...",
      allowOutsideClick: false,
      didOpen: () => { this._swal.showLoading() }
    })
  }

  /**
   * It closes the loading screen.
   */
  hiddeLoading(){
    this._swal.close();
  }

  /**
   * "This function shows an alert with the given parameters, and if the user confirms the alert, it
   * will execute the callbackConfirmer function, and if the user cancels the alert, it will execute
   * the callbackCanceled function."</code>
   * 
   * 
   * 
   * I'm trying to make a function that shows an alert with the given parameters, and if the user
   * confirms the alert, it will execute the callbackConfirmer function, and if the user cancels the
   * alert, it will execute the callbackCanceled function.
   * @param {string} title - The title of the alert.
   * @param {string} message - The message you want to display.
   * @param {SweetAlertIcon} icon - SweetAlertIcon =&gt; this is the icon that will be displayed on the
   * alert.
   * @param {boolean} [showCancelButton=false] - boolean = false,
   * @param {boolean} [allowOutsideClick=false] - boolean = false,
   * @param {string} [txtConfirmButton=OK] - string = "OK"
   * @param {string | undefined} [txtCancelButton] - string | undefined,
   * @param {any | undefined} [callbackConfirmer] - This is the function that will be called when the
   * user clicks the confirm button.
   * @param {any | undefined} [callbackCanceled] - This is the function that will be called when the
   * user clicks the cancel button.
   */
  showAlert(
    title             : string,
    message           : string,
    icon              : SweetAlertIcon,
    showCancelButton  : boolean = false,
    allowOutsideClick : boolean = false,
    txtConfirmButton  : string = "OK",
    txtCancelButton?  : string | undefined,
    callbackConfirmer?: any | undefined,
    callbackCanceled? : any | undefined
  ){
    this._swal.fire({
      title,
      html: message,
      icon,
      showCancelButton,
      allowOutsideClick,
      confirmButtonColor:"#0E71CE",
      cancelButtonColor: '#d33',
      confirmButtonText: txtConfirmButton,
      cancelButtonText: txtCancelButton,
    }).then(( result ) =>{
      if( result.isConfirmed ){
        if( callbackConfirmer != undefined ) callbackConfirmer()
      } else{
        if( callbackCanceled != undefined ) callbackCanceled()
      }
    })
  }


  
  /**
   * If the form control has the error validator, return true, otherwise return false.
   * @param {FormGroup} form - FormGroup - The form group that contains the control you want to
   * validate.
   * @param {string} controlName - The name of the control you want to validate.
   * @param {string} validator - string - The name of the validator you want to check for.
   * @returns A boolean value.
   */
  errorFormControl( form: FormGroup | FormControl, controlName: string, validator: string ) : boolean{
    return (form as FormGroup).controls[controlName].hasError(validator)
  }
}
